import { FC, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Content from '../../../components/Content/Content';
import { getProjectData } from '../../../redux/PublicFormSlice/PublicFormSelectors';
import { RemoteStatus } from '../../../redux/SharedTypes';
import PublicFormContext from '../Context/PublicFormContext';
import PublicFormBody from './PublicFormBody/PublicFormBody';

import styles from './PublicFormView.module.scss';

const messages = defineMessages({
	metaDescription: {
		id: 'payments.public_payment',
		defaultMessage: 'Public payment',
	},
});

const PublicFormView: FC = () => {
	const { locale, formatMessage } = useIntl();
	const { name } = useSelector(getProjectData)!;
	const { push } = useHistory();
	const { action } = useContext(PublicFormContext);
	const { data: created, status: createStatus } = action;

	useEffect(() => {
		if (!created || createStatus !== RemoteStatus.Done) return;
		push(`/${locale}/payment/preorder/${created.id}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [createStatus]);

	return (
		<>
			<Helmet
				htmlAttributes={{ lang: locale }}
				title={`SpectroCoin - ${formatMessage(messages.metaDescription)}`}
				meta={[{ name: 'description', content: formatMessage(messages.metaDescription) }]}
			/>
			<Content name={name}>
				<div className={styles.container}>
					<PublicFormBody />
				</div>
			</Content>
		</>
	);
};

export default PublicFormView;
